import React, { useContext, useEffect, useState } from 'react';
import {
  Card, CardContent, Typography, Grid, Avatar, Divider,
} from '@mui/material';
import { Modal } from 'react-bootstrap';
import { FaEdit } from 'react-icons/fa';
import toast from 'react-hot-toast';
import { Button } from '@/shared/components/Button';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import CryptoJS from 'crypto-js';
import { AuthContext } from '../../../context/AuthContext';
import { GlobalContext } from '../../../context/GlobalContext';
import EditProfile from './EditProfile';
import { SideBarRefreshContext } from '../../../context/SideBarRefreshContext';

const Profile = () => {
    const {
 agentId, userId, SetCurrencyCode, setCurrencyType, countryId,
} = useContext(AuthContext);
    const { apiGlobal } = useContext(GlobalContext);
    const [userData, setUserData] = useState([]);
    const [img, setImage] = useState(`${apiGlobal}/images/agent`);
    const [showEditModal, setShowEditModal] = useState(false);
    const [buttonDiabled, setButtonDisabled] = useState(false);
    const { sideBarRefresh } = useContext(SideBarRefreshContext);
    const fetchUserData = async () => {
       const formData = new FormData();
        formData.append('id', agentId);
        formData.append('country_id', countryId);
        try {
            const url = await fetch(`${apiGlobal}/agent_data_fetch.php`, {
              method: 'POST',
              body: formData,
            });
            const response = await url.json();
            if (response?.status && response?.message === 'Success') {
                setUserData(response.data[0]);
                // console.log(response.data[0]);
            } else {
                console.log(response?.message);
                setUserData([]);
            }
        } catch (error) {
            console.log(error);
        }
    }; 

    // const getCurrencyCode = async (countryId) => {
    //   const formData = new FormData();
    //   formData.append('country_id', countryId);
    //   try {
    //     const url = await fetch(`${apiGlobal}/get_currency_code.php`, {
    //       method: 'POST',
    //       body: formData,
    //     });
    //     const response = await url.json();
    //     if (response?.status && response?.message === 'Success') {
    //       const currencyCode = response.data.currency_name;
    //       const currencyType = countryId;
    //       SetCurrencyCode(currencyCode);
    //       setCurrencyType(currencyType); // currency id

     
    //      const encryptedCurrencyCode = CryptoJS.AES.encrypt(
    //     currencyCode.toString(),
    //     'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2',
    //   ).toString();

    //      const encryptedCurrencyType = CryptoJS.AES.encrypt(
    //     currencyType.toString(),
    //     'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2',
    //   ).toString();



    //   localStorage.setItem('99117114114101110991219599111100101', encryptedCurrencyCode);
    //   localStorage.setItem('78582826978678984898069', encryptedCurrencyType);
    //     } else {
    //       console.log(response?.message);
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // };

    useEffect(() => {
        fetchUserData();
    }, [sideBarRefresh?.agentProfileRefresh]);

    const handleEditProfile = async (values) => {
      setButtonDisabled(true);
       

      const formData = new FormData();
      formData.append('id', values.id);
      formData.append('agentName', values.name);
      formData.append('addressLine1', values.address1);
      formData.append('addressLine2', values.address2);
      formData.append('area', values.area);
      formData.append('uan', values.uan);
      formData.append('city', values.city);
      formData.append('state', values.state);
      formData.append('country', values.country);
      formData.append('logo', values.file);
      formData.append('gst_no', values.gst_no);
      formData.append('gst_type', values.gst_type);
      formData.append('gst_proof_file', values.gstProof);
      formData.append('pincode', values.pincode);
      formData.append('address_proof_file', values.addressProof);
      formData.append('defaultMarkup', values.markup);
      formData.append('locationOnMap', values.location);
      formData.append('taxId', values.tax_id);
      formData.append('taxCity', values.tax_city);
      formData.append('upper_limit', values.upper_limit);

      formData.append('type', 1);
      formData.append('user_id', userId);

      try {
        const response = await fetch(`${apiGlobal}/agent_edit.php`, {
          method: 'POST',
          body: formData,
        });
        const data = await response.json();
        if (data.status) {
          toast.success('Profile Update successful!');
          fetchUserData();
          // getCurrencyCode(values.country);
          setShowEditModal(false);
        } else {
          toast.error('Something went wrong. Please try again.');
        }
      } catch (error) {
        toast.error(`An Error Occurred: ${error.message}`);
      } finally {
        setButtonDisabled(false);
      }
    };

  return (
    <div>
      <Breadcrumbs 
        aria-label="breadcrumb"
        style={{
          marginLeft: '12px',
        }}
      >
        <Typography sx={{ color: 'text.primary' }}>Agent</Typography>
        <Typography sx={{ color: 'text.primary' }}>Profile</Typography>
      </Breadcrumbs>
      <div className="container" style={{ backgroundColor: '#f4f7fc', padding: '10px', borderRadius: '8px' }}>
       
        <Grid container spacing={3}>
          {/* Profile Section */}
          <Grid item xs={12} md={4}>
            <Card sx={{ borderRadius: '12px', boxShadow: 3 }}>
              <CardContent className="text-center">
                <Avatar
                  alt={userData?.name || 'NA'}
                  src={`${img}/${userData?.logo}`}
                  sx={{
                  width: 180, height: 180, margin: '0 auto', borderRadius: '50%', border: '4px solid #4caf50',
                }}
                />
                <Typography variant="h5" component="div" sx={{ mt: 3, fontWeight: 600 }}>
                  {userData?.name || 'NA'}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {userData?.user_email || 'NA'}
                </Typography>
                <div style={{
 display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', margin: '12px', 
}}
                >
                  <Button
                    variant="primary-outline"
                    sx={{ mt: 4, padding: '8px 20px' }}
                    onClick={() => setShowEditModal(true)}
                  >
                    <FaEdit style={{ marginRight: '8px' }} /> Edit Profile
                  </Button>
                  {/* <Button variant="primary-outline">
                    Change Password
                  </Button> */}
                </div>
              
              </CardContent>
            </Card>
          </Grid>

          {/* User Details Section */}
          <Grid item xs={12} md={8}>
            <Card sx={{ borderRadius: '12px', boxShadow: 3 }}>
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>Address Details</Typography>
                <Divider sx={{ margin: '10px 0' }} />
                <Typography variant="body1"><strong>Address 1:</strong> {userData?.address1 || 'NA'}</Typography>
                <Typography variant="body1"><strong>Address 2:</strong> {userData?.address2 || 'NA'}</Typography>
                <Typography variant="body1"><strong>Area:</strong> {userData?.area || 'NA'} 
                  <strong>&nbsp;&nbsp;City:</strong> {userData?.city || 'NA'}
                </Typography>
                <Typography variant="body1"><strong>State:</strong> {userData?.state || 'NA'} 
                  <strong>&nbsp;&nbsp;Country:</strong> {userData?.country_name || 'NA'}
                </Typography>
              </CardContent>
            </Card>

            <Divider sx={{ margin: '15px 0' }} />

            <Card sx={{ borderRadius: '12px', boxShadow: 3 }}>
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>Tax Details</Typography>
                <Typography variant="body1">
                  <strong>Tax Identification No:</strong> {userData?.tax_id || 'NA'}
                </Typography>
                <Typography variant="body1"><strong>Tax City:</strong> {userData?.tax_city || 'NA'}</Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Additional Cards Below */}
        <Grid container spacing={3} className="mt-4">
          <Grid item xs={12} md={6}>
            <Card sx={{ borderRadius: '12px', boxShadow: 3 }}>
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>GST Details</Typography>
                <Divider sx={{ margin: '10px 0' }} />
                <Typography variant="body1"><strong>GST No:</strong> {userData?.gst_no || 'NA'}</Typography>
                <Typography variant="body1"><strong>GST Type:</strong> {userData?.gst_type || 'NA'}</Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card sx={{ borderRadius: '12px', boxShadow: 3 }}>
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>Other Details</Typography>
                <Divider sx={{ margin: '5px 0' }} />
                <Typography variant="body1"><strong>UAN:</strong> {userData?.uan || 'NA'}</Typography>
                <Typography variant="body1"><strong>Default Markup:</strong> {userData?.markup || 'NA'}</Typography>
                <Typography variant="body1"><strong>Credit Limit:</strong> {userData?.upper_limit || 'NA'}</Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Modal
          show={showEditModal}
          onHide={() => setShowEditModal(false)}
          centered
          size="xl"
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Edit Profile</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <EditProfile 
              formValues={userData}
              onSubmit={handleEditProfile}
              buttonDiabled={buttonDiabled}
              setShowEditModal={setShowEditModal}
            />
          </Modal.Body>
        </Modal>
      </div>
    </div>
   
  );
};

export default Profile;
